<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col v-if="orderTagOptions.length > 0">
        <b-form-group>
          <label>{{$t("views.exsborder.form.tags")}}: </label>
          <multi-select :options="orderTagOptions" :selected-options="item.orderTags" @select="onSelectTags" >
          </multi-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="!isWholesaler">
        <b-form-group>
          <label class="form-control-label">
            {{$t('views.exsborder.form.firm')}}:
          </label>
          <base-select-input
            v-model="item.firm"
            :search-callback="userDataSearchCallback"
            :query-param="'userdata'"
            :display-values="['fullName', 'firmname1']"
            :disabled="isCaseShowView || (!!item['@id'] && !!item.firm)"
            :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
          ></base-select-input>
          <div
            v-if="isInvalid('firm')"
            class="invalid-feedback">{{ violations.firm }}</div>
        </b-form-group>
      </b-col>
      <b-col>
        <label class="form-control-label">
          {{$t('views.excmcasetype.form.enablePartner')}}:
        </label>
        <base-select-input
          v-model="item.contractor"
          :search-callback="partnerSearchCallback"
          :query-param="'userdata'"
          :display-values="['fullName', 'firmname1']"
          :disabled="isCaseShowView || (!!item['@id'] && !!item.contractor)"
          :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
        ></base-select-input>
      </b-col>
      <b-col>
        <label
          class="form-control-label">{{$t('views.excmnote.form.idCase')}}
        </label>
        <BaseSelectInput
          v-if="!idExtractedOrder"
          ref="caseInput"
          v-model="item.idCase"
          :search-callback="caseSearchCallback"
          :display-values="['title', 'contractorUserData.fullName', 'contractorUserData.firmname1']"
          :query-param="'contractor'"
          :disabled="isCaseShowView || (!!item['@id'] && !!item.idCase)"
          :placeholder-autocomplete="'Zacznij wpisywać kontrahenta'"
          :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
        ></BaseSelectInput>
        <b-alert v-else show variant="info">{{$t('views.exsborder.form.idExtractedOrderInfo')}}</b-alert>
      </b-col>
    </b-row>
    <b-row v-if="item.positions.length > 0">
      <b-col>
        <table class="table table-sm table-responsive-md table-grid table-hover">
          <thead>
          <tr>
            <th></th>
            <th class="w-50">{{$t('views.exsborder.form.positions.item')}}</th>
            <th v-if="item.lockedPositions">{{$t('views.exsborder.form.positions.quantityLocked')}}</th>
            <th v-if="item.lockedPositions">{{$t('views.exsborder.form.positions.quantityCompleted')}}</th>
            <th v-else>{{$t('views.exsborder.form.positions.quantity')}}</th>
            <th>{{$t('views.exsborder.form.positions.measure')}}</th>
            <th>{{$t('views.exsborder.form.positions.valueBrutto')}}</th>
            <th class="w-2"></th>
          </tr>
          </thead>
          <tbody v-for="(position, positionIndex) in item.positions" :key="'position-' + positionIndex">
          <tr>
            <td>
              <div v-if="position.picturePreview" :id="'image_'+positionIndex" class="picturebox" style="max-height: 35px; max-width: 35px">
                <b-img style="object-fit: fill;" :src="position.picturePreview" alt="picture"/>
                <b-tooltip :target="'image_'+positionIndex">
                  <b-img :src="position.picturePreview" alt="picture"/>
                </b-tooltip>
              </div>
            </td>
            <td>
              <base-select-input
                :disabled="Boolean(item.lockedPositions && item.lockedPositions[positionIndex])"
                class="w-100"
                :id="'position_item_'+positionIndex"
                v-model="position.item"
                :search-callback="itemSearchCallback"
                :query-param="'name'"
                :display-values="['name']"
                :is-auto-complete-mode="true"
                @input="handleSelectItem($event, positionIndex)"
              ></base-select-input>
            </td>
            <td v-if="item.lockedPositions">
              <el-input-number v-if="item.lockedPositions[positionIndex]"
                :id="'locked_position_quantity_'+positionIndex"
                :value="item.lockedPositions[positionIndex].quantity"
                :disabled="true"
                :min="1">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                @input="quantityHandler(positionIndex)"
                :id="'position_quantity_'+positionIndex"
                v-model="position.quantity"
                :min="(item.lockedPositions && item.lockedPositions[positionIndex]) ? 0 : 1">
              </el-input-number>
            </td>
            <td>
              <div v-if="position.measureName">
                {{ position.measureName }}
              </div>
            </td>
            <td>
              <div v-if="position.valueBrutto">
                {{ position.valueBrutto }}
              </div>
            </td>
            <td>
              <button
                :disabled="Boolean(item.lockedPositions && item.lockedPositions[positionIndex])"
                type="button"
                class="btn btn-link fa fa-trash fa-lg"
                @click="removeItemCollection(positionIndex)"
                v-b-tooltip.hover :title="$t('buttons.delete')">
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3">
        <b-btn @click="addNewPosition()">{{$t('views.exsborder.form.addNewPosition')}}</b-btn>
      </b-col>
      <b-col cols="9" v-if="!addPositionsFromCsvEnabled">
        <b-btn class="float-right" @click="addPositionsFromCsv()">{{$t('views.exsborder.form.addPositionsFromCsv')}}</b-btn>
      </b-col>
      <b-col cols="9" v-if="addPositionsFromCsvEnabled">
        <b-row>
          <b-col cols="8">
            <b-form-file class="float-right" browse-text="Przeglądaj" ref="file-input" name="document" accept=".csv" v-model="dataFile" :state="Boolean(document)" :placeholder="'Przeciągnij i upuść plik lub kliknij przeglądaj'"></b-form-file>
          </b-col>
          <b-col>
            <b-btn class="float-right" @click="addPositionsFromCsvAction()">{{$t('views.exsborder.form.addPositionsFromCsvAction')}}</b-btn>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-alert class="mt-2" v-if="addPositionsFromCsvSuccess" show variant="info">{{$t('views.exsborder.form.orderLoadedFromFileInfo')}}</b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <button :disabled="idExtractedOrder && !idCaseTypeForOrderExtraction" type="submit" class="btn btn-primary">{{ $t('buttons.submit') }}</button>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import ApiService from '@/utils/ApiService'
import { mapActions, mapGetters } from 'vuex'
import { MultiSelect } from 'vue-search-select'
import addParamsToQuery from '@/utils/addParamsToQuery'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'
import getId from '@/utils/getIdFromLink'
import remove from '@/utils/remove'
import { getUserRoles } from '@/utils/checkRoles'

export default {
  components: {
    MultiSelect,
    BaseSelectInput
  },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },
    handleUpdateField: {
      type: Function,
      required: true
    },
    values: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => {}
    },
    initialValues: {
      type: Object,
      default: () => {}
    },
    idFirm: String,
    idContractor: String,
    idCase: String,
    idExtractedOrder: String,
    idCaseTypeForOrderExtraction: String
  },
  data () {
    return {
      addPositionsFromCsvEnabled: false,
      addPositionsFromCsvSuccess: false,
      dataFile: '',
      firmsOptions: [],
      orderTagOptions: []
    }
  },
  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },
    violations () {
      return this.errors || {}
    },
    isCaseShowView () {
      return this.$route.name === 'EXCMCaseShow'
    },
    isWholesaler () {
      return getUserRoles().roles.includes('ROLE_WHOLESALER')
    },
    ...mapGetters({
      measureOptions: 'exsbmeasure/list/items',
      itemOptions: 'exsbitem/list/items'
    })
  },
  created () {
    this.getMeasures()
    this.fetchOrderTagOptions()
    if (this.idFirm) {
      this.item.firm = this.idFirm
    }
    if (this.idContractor) {
      this.item.contractor = this.idContractor
    }
  },
  methods: {
    ...mapActions({
      fetchMeasures: 'exsbmeasure/list/default',
      fetchItems: 'exsbitem/list/getItems'
    }),
    quantityHandler (positionIndex) {
      let position = this.item.positions[positionIndex]
      position.valueNetto = (position.pricePerUnitNetto * position.quantity).toFixed(2)
      position.valueBrutto = (position.pricePerUnitBrutto * position.quantity).toFixed(2)
      this.$forceUpdate()
    },
    async handleSelectItem (id, positionIndex) {
      let item = await this.getItem(getId(id))
      let position = this.item.positions[positionIndex]
      if (position.item) {
        position.measure = item.measure['@id']
        position.measureName = item.measure.name
        position.vatRate = item.vatRate['@id']
        position.pricePerUnitNetto = (item.priceNetto).toString()
        position.pricePerUnitBrutto = (item.priceBrutto).toString()
        position.valueNetto = (item.priceNetto * position.quantity).toFixed(2)
        position.valueBrutto = (item.priceBrutto * position.quantity).toFixed(2)
        position.picturePreview = this.getPicturePreview(item)
      }
      this.$forceUpdate()
    },
    getPicturePreview (item) {
      let defaultPicturePreview = '/static/img/no-image.png'
      if (item.itemPictures && item.itemPictures.length > 0) {
        let picturePreview = item.itemPictures.find(itemPicture => itemPicture.isMain === 1).picturePreview
        return picturePreview || defaultPicturePreview
      } else {
        return defaultPicturePreview
      }
    },
    async itemSearchCallback (params = {}) {
      let baseParams = { pagination: false, state: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_s_b_items', baseParams).getResults()
      return response.items
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false, isContractor: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    async partnerSearchCallback (params = {}) {
      let baseParams = { pagination: false, isCompany: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    async caseSearchCallback (params = {}) {
      let baseParams = { pagination: false, contractorUserData: this.idFirm ? getId(this.idFirm) : getId(this.item.contractor) }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_c_m_cases', baseParams).getResults()
      return response.items
    },
    getItem (id) {
      if (id) {
        return new ApiService(`e_x_s_b_items/${id}`).getResults()
      }
    },
    removeItemCollection (index) {
      let currentPosition = this.item.positions[index]
      if (currentPosition['@id']) {
        remove(currentPosition['@id'], () => {
          this.item.positions.splice(index, 1)
        })
      } else {
        this.item.positions.splice(index, 1)
      }
    },
    addNewPosition () {
      let object = {
        pricePerUnitBrutto: '0.00',
        pricePerUnitNetto: '0.00',
        quantity: 1,
        discount: '0',
        valueNetto: '0.00',
        valueBrutto: '0.00',
        vatRate: '',
        item: null,
        measure: ''
      }
      this.item.positions.push(object)
    },
    addPositionsFromCsv () {
      this.addPositionsFromCsvEnabled = true
    },
    addPositionsFromCsvAction () {
      let formData = new FormData()
      formData.append('dataFile', this.dataFile)
      formData.append('idCase', this.item.idCase)
      this.$http.post('api/prepare_order_from_file',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        if (response.status === 200) {
          this.$Swal({
            type: 'success',
            title: this.$t('notifications.store.savedTitle'),
            timer: 2500
          })
          this.item.positions = response.data
          this.addPositionsFromCsvSuccess = true
          this.item.addPositionsFromCsvSuccess = true
          this.$forceUpdate()
        } else if (response.status === 207) {
          let text = ''
          for (let i in response.data) {
            text += response.data[i] + '\n'
          }
          this.$Swal({
            type: 'warning',
            title: text,
            timer: 2500
          })
        }
      }).catch(error => {
        if (error.response.status === 400) {
          let text = error.response.data['hydra:description']
          this.$Swal({
            type: 'warning',
            title: text,
            timer: 2500
          })
        }
        console.log(error)
      })
    },
    getMeasures () {
      let link = addParamsToQuery('e_x_s_b_measures',
        {
          pagination: false
        }
      )
      this.fetchMeasures(link)
    },
    async fetchOrderTagOptions () {
      let baseParams = { pagination: false, tagType: 4 }
      const response = await new ApiService('e_x_c_m_tags', baseParams).getResults()
      this.orderTagOptions = response.items.map(tag => {
        return {
          value: tag['@id'],
          text: tag.tag
        }
      })
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    onSelectTags (items, lastSelectItem) {
      this.item.orderTags = items
      this.lastSelectTag = lastSelectItem
    }
  }
}
</script>
